import React, { useEffect, useState } from 'react';
import { useQuery, useMutation, gql } from '@apollo/client';
import { useYourComponentContext } from './IdSeqContext2';


const GET_ID_SEQ = gql`
  query GetIdSeq($type: String!) {
    tbl_id_SEQ(where: { type: { _eq: $type } }) {
      id_seq
    }
  }
`;

const UPDATE_ID_SEQ = gql`
  mutation UpdateIdSeq($type: String!, $id_seq: Int!) {
    update_tbl_id_SEQ(
      where: { type: { _eq: $type } }
      _set: { id_seq: $id_seq }
    ) {
      returning {
        id_seq
      }
    }
  }
`;


function YourComponent({ type }) {
  const { loading, error, data } = useQuery(GET_ID_SEQ, {
    variables: { type },
  });

  const [updateIdSeq] = useMutation(UPDATE_ID_SEQ);
// const [newId, setNewId] = useState("tmuaest");
 const { newId, setNewId } = useYourComponentContext();

  useEffect(() => {
    if (!loading && !error && data) {
      console.log('ID_SEQ:', data.tbl_id_SEQ[0].id_seq);

      const updatedId = data.tbl_id_SEQ[0].id_seq + 1;
      updateIdSeq({
        variables: { type, id_seq: updatedId },
      })
        .then((result) => {
          const updatedIdFromMutation = result.data.update_tbl_id_SEQ.returning[0].id_seq;
          console.log('ID_SEQ güncellendi:', updatedIdFromMutation);
          setNewId(updatedIdFromMutation);

        })
        .catch((mutationError) => {
          console.error('Hata:', mutationError);
        });
    }
  }, [loading, error, data, type, updateIdSeq]);

  if (loading) {
    return <div>Sorgu yükleniyor...</div>;
    
  }
  

  if (error) {
    console.error('Hata:', error);
    return null;
  }

  return <div>ID_SEQ: {data.tbl_id_SEQ[0].id_seq}
   <div>
      ID_SEQ: {newId}
      
    </div>
    </div>;
  
}

export default YourComponent;


/*

const IdSeqContext = createContext();

export const IdSeqProvider = ({ children }) => {
  const [idSeq, setIdSeq] = useState(0);

  const updateIdSeq = async (type) => {
    // Burada GraphQL veya diğer güncelleme mantıklarınızı ekleyin
    // Ve güncellenmiş id_seq'i alın
    const updatedIdSeq = await performUpdateIdSeq(type);

    // Güncellenmiş id_seq'i state'e kaydedin
    setIdSeq(updatedIdSeq);

    return updatedIdSeq;
  };

  return (
    <IdSeqContext.Provider value={{ idSeq, updateIdSeq }}>
      {children}
    </IdSeqContext.Provider>
  );
};

export const useIdSeqUpdater = () => {
  const context = useContext(IdSeqContext);

  if (!context) {
    throw new Error('useIdSeqUpdater IdSeqProvider içinde kullanılmalıdır');
  }

  return context.updateIdSeq;
};

export const useIdSeq = () => {
  const context = useContext(IdSeqContext);

  if (!context) {
    throw new Error('useIdSeq IdSeqProvider içinde kullanılmalıdır');
  }

  return context.idSeq;
};

/* diger sayfadan cagırma

 import React from 'react';
import { IdSeqProvider, useIdSeqUpdater, useIdSeq } from './IdSeqContext';

const YourComponent = () => {
  const updateIdSeq = useIdSeqUpdater();
  const idSeq = useIdSeq();

  const handleUpdateIdSeq = async () => {
    try {
      // Her çağrıda  parametre 
      const updatedIdSeq = await updateIdSeq('MFIRM');
      console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
    } catch (error) {
      console.error('Güncelleme hatası:', error);
    }
  };

  return (
    <div>
      <h1>Your Component</h1>
      <p>ID_SEQ: {idSeq}</p>
      <button onClick={handleUpdateIdSeq}>ID_SEQ Güncelle</button>
    </div>
  );
};

const App = () => {
  return (
    <IdSeqProvider>
      <YourComponent />
    </IdSeqProvider>
  );
};

export default App; */
